import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    tabsOffset: {
      margin: theme.spacing(-1, -2, 0, -2),
    },
    activeContent: {
      display: 'block',
      background: 'white',
      width: '100%',
      height: '100%',
      overflow: 'auto',
    },
    contentTabs: {
      flexGrow: 1,
      padding: theme.spacing(1, 0),
    },
    divider: {
      margin: theme.spacing(3, 0),
    },
    dateRangeSelector: {
      maxWidth: theme.spacing(40),
    },
  };
};
